import React from 'react';
import 'animate.css';
import { FaGithub, FaLinkedin, FaEnvelope, FaPhone } from 'react-icons/fa';
import { SiLeetcode } from 'react-icons/si';

const Conract = () => {
  return (
   <section id='contact'>
     <div className="flex flex-col items-center justify-between min-h-screen bg-gray-900 text-white p-8">
      <h2 className="text-3xl font-bold text-center mb-8 animate__animated animate__fadeInDown">

      <span className="relative inline-block">
            Contact Me
            <div className='h-2'></div>
            <span className="absolute bottom-0 left-0 w-full h-1 bg-transparent">
              <span className="absolute bottom-0 left-0 w-full h-full bg-blue-400 animate-drawLine"></span>
            </span>
          </span>
      </h2>
      <div className="flex flex-col items-center text-center mb-8 animate__animated animate__fadeInUp">
        <p className="font-bold text-lg mb-4">
          Feel free to reach out to me through any of the following platforms or send me a message directly:
        </p>
      </div>
      <div className="mt-8 flex justify-center gap-8 mb-12 ">
        <a href="mailto:your-nikhilbhalkar23@gmail.com" target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-red-500 transition-colors duration-300">
          <FaEnvelope size={40} />
        </a>
        <a href="tel:+918010896019" target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-green-500 transition-colors duration-300">
          <FaPhone size={40} />
        </a>
        
        <a href="https://github.com/nikhilbhalkar" target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-gray-400 transition-colors duration-300">
          <FaGithub size={40} />
        </a>
        <a href="https://www.linkedin.com/in/nikhil-bhalkar-6a2b67260/" target="_blank" rel="noopener noreferrer" className="text-2xl hover:text-blue-600 transition-colors duration-300">
          <FaLinkedin size={40} />
        </a>
        
      </div>
      <form className="w-full max-w-lg animate__animated animate__fadeInUp">
        <div className="mb-4">
          <label className="block text-sm font-bold mb-2" htmlFor="name">Name</label>
          <input className="w-full px-3 py-2 text-black rounded-md" type="text" id="name" placeholder="Your name" />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-bold mb-2" htmlFor="email">Email</label>
          <input className="w-full px-3 py-2 text-black rounded-md" type="email" id="email" placeholder="Your email" />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-bold mb-2" htmlFor="subject">Subject</label>
          <input className="w-full px-3 py-2 text-black rounded-md" type="text" id="subject" placeholder="Subject" />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-bold mb-2" htmlFor="message">Message</label>
          <textarea className="w-full px-3 py-2 text-black rounded-md" id="message" rows="5" placeholder="Your message"></textarea>
        </div>
        <div className="flex justify-center">
          <button className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md transition-colors duration-300" type="submit">
            Send Message
          </button>
        </div>
      </form>
    </div>
   </section>
  );
};

export default Conract;
